import { render, staticRenderFns } from "./customizationMyProject.vue?vue&type=template&id=61768b48"
import script from "./customizationMyProject.vue?vue&type=script&lang=js"
export * from "./customizationMyProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports